import { ColumnConfig, PrincipalPaymentsColumnKey } from '../../model';

type PrincipalPaymentsConfig =
  | PrincipalPaymentsColumnKey
  | 'action'
  | 'utr'
  | 'InstrumentNo'
  | 'referenceTransactionNumber';

export const principalPaymentsConfig: Record<
  PrincipalPaymentsConfig,
  ColumnConfig
> = {
  // paymentId: {
  //   name: 'Payment Id',
  //   field: 'checkboxText',
  //   isCheckboxField: true,
  //   isHyperlink: true,
  //   headerExtra: {
  //     type: 'info',
  //     details:
  //       'The voucher number from your ERP (e.g., Tally) and the transaction ID from the UPI app will be available here',
  //     title: 'Payment Id',
  //   },
  // },

  paymentId: {
    name: 'Payment Id',
    field: 'component',
    headerExtra: {
      type: 'info',
      details:
        'The voucher number from your ERP (e.g., Tally) and the transaction ID from the UPI app will be available here',
      title: 'Payment Id',
    },
  },

  docType: {
    name: 'Doc Type',
  },
  utr: {
    name: 'UTR',
    headerExtra: {
      type: 'info',
      details: 'UPI or bank transaction ID will appear here',
      title: 'UTR',
    },
  },
  status: {
    name: 'Status',
    isComponent: true,
  },
  paymentDate: {
    name: 'Payment Date',
  },
  customerName: {
    name: 'Customer Name',
    isComponent: true,
  },
  // typeOfPayment: {
  //   name: 'Type Of Payment',
  // },
  modeOfPayment: {
    name: 'Payment Mode',
  },
  amount: {
    name: 'Amount',
    sortField: 'amount',
  },
  InstrumentNo: {
    name: 'Instrument Number',
    isVisible: false,
    isAdditional: true,
  },
  referenceTransactionNumber: {
    name: 'Reference Transaction Number',
    isVisible: false,
    isAdditional: true,
  },
  action: {
    name: 'Actions',
    isComponent: true,
    alignment: 'center',
  },
};
